import { PawPrint } from "lucide-react";

const ITEMS = [
  "NO REFILLS",
  "REUSABLE OVER AND OVER",
  "SELF-CLEANING",
  "FREE SHIPPING ON 2+ UNITS",
  "FOR DOGS AND CATS",
  "NO ADHESIVES",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee-strip" className="bg-ink text-white py-4 overflow-hidden select-none" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-6 mx-6 font-display text-sm font-semibold tracking-[0.15em]">
                {item}
                <PawPrint className="w-4 h-4 text-brand" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
